import React from 'react';
import { useLocation } from 'react-router-dom';
import { CustomImageSlider } from '@/components/hotel/ CustomImageSlider';
import ThreeImages from '../common/ThreeImages';
import Picture1 from '@/image/hotel/hotel_1.jpg';
import Picture2 from '@/image/hotel/hotel_2.jpg';
import Picture3 from '@/image/hotel/hotel_3.jpg';
import { NavigationButton } from '../common/NavigationButton';

export const AboutContent = () => {
  const location = useLocation();
  // URL の先頭セグメントを取得し、'en' なら英語、それ以外は日本語とする
  const langSegment = location.pathname.split('/')[1];
  const language = langSegment === 'en' ? 'en' : 'ja';

  const images = [
    {
      src: Picture1,
      title: 'Original and Hand Selected Furniture',
      place: 'Place 1',
      text: 'Original and Hand Selected Furniture',
      sizeClass: 'w-[460px] h-[679px]',
    },
    {
      src: Picture2,
      title: 'Kitchen & Coffee Amenities',
      place: 'Place 2',
      text: 'Kitchen & Coffee Amenities',
      sizeClass: 'w-[253px] h-[264px]',
    },
    {
      src: Picture3,
      title: 'Long and Short Stay',
      place: 'Place 3',
      text: 'Long and Short Stay',
      sizeClass: 'w-[400px] h-[477px]',
    },
  ];

  return (
    <div>
      <div className="flex justify-center">
        <div className="pt-14 md:pt-36 md:px-[300px] md:text-center text-lg">
          (ABOUT)
        </div>
      </div>
      <div className="flex justify-center">
        {language === 'en' ? (
          <p className="py-6 md:max-w-[600px] md:mb-24 text-[15px]">
            <p className="mb-3">What is the modern journey?</p>
            <p className="mb-3">
              It is a journey that allows one’s body to become accustomed to the
              local scenery and rhythm of life in a different place, and to
              experience the reality of the city. It is a journey to comfortably
              synchronize one’s own rhythm with the rhythm of the city. Become a
              part of the Neighborhood, not as a gentile.
            </p>
            Travel at your own pace, at the same pace as the locals, and savor
            the tactile experience of time. Apartment Hotel is a hotel brand for
            such a new kind of travel.
          </p>
        ) : (
          <p className="py-6 md:max-w-[600px] md:mb-24 text-[15px]">
            現代的な旅とは何か。
            それは、普段と違う土地のローカルな景色と生活のリズムに、自分の体とリズムを同期させ、ネイバーフッドの一部になる旅。
            特別なホテルに一泊するのではなく、その街の生活をリアルに感じられる部屋に、長く滞在する旅。
            ザ・アパートメントホテルは、東京への旅行者にそんな新しい旅の体験を提供する。
          </p>
        )}
      </div>

      <div className="pt-6 md:mt-16">
        <div className="md:px-[300px] text-center md:mb-[50px] text-lg">
          (ROOM)
        </div>

        {/* SP時のみ表示: CustomImageSlider */}
        <div className="md:hidden max-md:my-6">
          <CustomImageSlider
            startIndex={0}
            images={images}
            className="w-[251px] h-[355px]"
          />
          <div className="pt-10 flex justify-end">
            <CustomImageSlider
              startIndex={1}
              images={images}
              className="w-[160px] h-[160px]"
            />
          </div>
          <div className="pt-10 flex justify-end">
            <CustomImageSlider
              startIndex={2}
              images={images}
              className="w-[277px] h-[320px]"
            />
          </div>
        </div>

        {/* PC時のみ表示: ThreeImages */}
        <div className="hidden md:block">
          <ThreeImages images={images} />
        </div>

        {language === 'en' ? (
          <p className="py-6 md:max-w-[600px] md:mx-auto text-[15px]">
            <p className="mb-3">
              A cozy sofa and a large table for working or eating. The sun is
              shining, and with music playing comfortably through the speakers
              and a cup of coffee or a glass of wine, you can have a great time
              without needing anything else.
            </p>
            <p className="mb-3">
              Not a famous brand, but a favorite piece of furniture that you
              will want to keep for a long time and that you will love. The
              interior design is not about sophistication, but rather about a
              simple, temperature-controlled atmosphere. In such a relaxed space
              without being over-designed, you will find not expensive but
              thoughtful furniture, interior decorations, cups, and dishes.
            </p>
            {/* Art books, records,  */}
            books, and artists’ works are scattered here and there, giving the
            space the reality of living in the city of Tokyo.
          </p>
        ) : (
          <p className="py-6 md:max-w-[600px] md:mx-auto text-[15px]">
            居心地のいいソファと、大きなテーブル。シンプルだけれど、人の温度を感じる内装。キッチンに並ぶ、不揃いのカップや食器。部屋に点在する、本やアート。スピーカーから流れる、心地のいい音楽。コーヒーをドリップする、優しい音と香り。親しい友人や家族との、何気ない会話。東京の日常を、過不足なく味わうための部屋。
          </p>
        )}
      </div>
      <div>
        <div className="border-t border-black p-2 border w-fit mx-auto mt-4 text-[15px]">
          <NavigationButton
            to="/hotel/properties"
            text="View ALL ROOMS"
            className="text-black"
          />
        </div>
      </div>
    </div>
  );
};
